import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketMandatoryFeesTemplate from './BasketMandatoryFeesTemplate';
import { rem } from 'polished';

export const BasketMandatoryFeesStyled = styled(BasketMandatoryFeesTemplate)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .Collapsible__contentInner {
        padding-bottom: ${rem(30)};
    }
    
    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }
    
    .fees {
        display: flex;
        justify-content: space-between;
        
        @media (max-width: ${breakpoints.md}px) {
            flex-direction: column;
        }
        
        .items, .description {
            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }
        }
        
        .items {
            @media (max-width: ${breakpoints.md}px) {
                padding-top: ${rem(30)};
            }
        }
        
        .item {
            padding: ${rem(16)} 0;
            border-top: 1px solid ${({ theme }) => theme.colors.grey28};
            
            &_description_full {
                -webkit-line-clamp: unset !important;
            }
            
            &_description_min {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
            
            &_description {
                p {
                    margin: 0;
                }
            }
            
            &_title {
                padding-bottom: ${rem(10)};
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                display: flex;
                justify-content: space-between;
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }
            
            &_link {
                padding-top: ${rem(10)};
                
                button {
                    background: none;
                    border: none;
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                    padding: 0;
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
            
            &:last-child {
                border-bottom: 1px solid ${({ theme }) => theme.colors.grey28};
            }
        }
    }
`;
